// Pure-CSS pulsing stock indicator — zero JS, zero extra assets.
export function StockBadge({ label = "In stock" }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-2">
      <span className="relative flex h-2.5 w-2.5 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
      </span>
      <span className="font-semibold text-emerald-700">{label}</span>
    </span>
  );
}
